import React from 'react';
import authenticationProvider from '../../../../utilities/authentication/authenticationProvider';

const InvoiceLoginRedirect = (props) => {

  const handleLoginRedirect = () => {
    authenticationProvider.redirectToLogin(location.pathname,'');
  };

  return (
    <>
      <div className="invoice-login-redirect-container">
        <div className="prompt-message">לצפייה בחשבוניות עליך להתחבר עם פרטי המשלם</div>
        <div className='login-button-container'>
          <div className="login-button" onClick={handleLoginRedirect}>
                התחברות
          </div>
        </div>
      </div>
   </>
  );
};
export default InvoiceLoginRedirect;
